import { put, call } from 'redux-saga/effects';
import {
    getQueueSuccessAction,
    getQueueFailureAction,
    getSilentQueueSuccessAction,
    getSilentQueueFailureAction
} from '../actions/queueActions';
import { END_POINTS } from '../../api/endpoints';
import { API } from '../../api/api';

export function* getQueueData(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const { date, hospitalId } = action.payload || {};
        const queueResponse = yield call(
            API.get,
            `${baseUrl}${END_POINTS.getQueue(date, hospitalId)}`,
        );
        
        if (queueResponse.success) {
            yield put(getQueueSuccessAction(queueResponse.data));
        }
        else {
            throw new Error(queueResponse.message)
        }
    } catch (error) {
        yield put(getQueueFailureAction(error.message));
    }
}


export function* getSilentlyQueueData(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const { date, hospitalId } = action.payload || {};
        const queueResponse = yield call(
            API.get,
            `${baseUrl}${END_POINTS.getQueue(date, hospitalId)}`,
        );
        
        if (queueResponse.success) {
            yield put(getSilentQueueSuccessAction(queueResponse.data));
        }
        else {
            throw new Error(queueResponse.message)
        }
    } catch (error) {
        yield put(getSilentQueueFailureAction(error.message));
    }
}


